import { DealernetApi } from "./DealernetApi";

export class QuoteService {
  /**
   * Gets quotes
   *
   * @static
   * @param { accountId: number, userId: number, dealerCode: string, pageNumber: number, pageSize: number } params
   */
  static getQuotes(params) {
    return DealernetApi.client().get("/Quotes/QuoteHeaders", {
      params
    });
  }

  /**
   * Gets quote detail
   *
   * @static
   * @param { accountId: number, userId: number, quoteNumber: string } params
   */
  static getQuoteDetail(params) {
    return DealernetApi.client().get("/Quotes/QuoteDetails", {
      params
    });
  }

  /**
   * Submit quote
   *
   * @static
   * @param { accountId: number, userId: number } params
   * @param { UserFullName: string, UserEmail: string, PoNumber: string, ShippingMethod: string, EmailNotes?: string, QuoteNumber: string } data
   */
  static submitQuote(params, data) {
    return DealernetApi.client().post("/Quotes/SubmitQuote", data, {
      params
    });
  }
}
